import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";

export const Wrap = styled.div`
  height: 100vh;
  height: 100dvh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding-top: 24px;
`;

export const InnerWrap = styled.div`
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
`;

export const RentioLogo = styled.img`
  display: block;
  width: ${200 / 2}px;
  height: ${52 / 2}px;
`;

export const ButtonsWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const LinkInfo = styled.a`
  font-size: 12px;
  text-decoration: none;
  color: ${props => props.theme.colors.global2};
`;

export const LinkNotFound = styled.span`
  font-size: 12px;
  color: ${props => props.theme.colors.global2};
`;
